var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigCommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.553,13.424h2.594c.738,0,1.205-.406,1.205-1.06,0-.615-.467-1.06-1.205-1.06h-2.594c-.086,0-.16.074-.16.148v1.82c.012.086.074.148.16.148v.005Zm0,4.193h2.68c.824,0,1.316-.418,1.316-1.156,0-.643-.467-1.156-1.316-1.156h-2.68c-.086,0-.16.074-.16.148v2.004c.012.098.074.16.16.16ZM22.045,1.768l-7.672,7.648h1.254c1.955,0,3.111,1.23,3.111,2.57,0,1.06-.713,1.832-1.478,2.176-.123.049-.123.225.012.271.885.344,1.512,1.266,1.512,2.348,0,1.525-1.021,2.742-3,2.742h-5.432c-.086,0-.16-.074-.16-.148v-5.791L1.769,21.969c-.111.111-.037.308.123.308h20.251c.074,0,.135-.064.135-.135V1.879c.037-.135-.135-.209-.234-.111h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigCommerce);
export default __webpack_public_path__ + "static/media/big-commerce.a2a0127270cf9deb8bea0030cc48014d.svg";
export { ForwardRef as ReactComponent };